module.exports = __webpack_public_path__ + "img/bangladesh.568b29ae.svg";